import React from 'react';
import { USBButton } from '@usb-shield/forms-beta';
import { Recommendations as RecommendationsComponent } from '@usb-onboarding/product-recommender-components';
import styles from './recommendations.module.scss';

function Recommendations({
    title,
    content,
    imageUrl,
    recommendations,
    goToAllResults,
    restartRecommender,
    buttonCallback,
}) {
    return (
        <>
            <div className={styles['main-content-wrapper']}>
                <div className={styles['main-left-content']}>
                    <h1 className={styles.title}>{title}</h1>
                    <div
                        className={styles.content}
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                    <div className={styles.recommendations}>
                        <RecommendationsComponent
                            buttonCallback={buttonCallback}
                            recommendations={recommendations}
                        />
                    </div>
                    <div className={styles['results-footer']}>
                        <h2>Still not your fit?</h2>
                        <div className={styles['button-container']}>
                            <USBButton
                                variant="text"
                                ariaLabel="Show all the available products"
                                onSubmit={goToAllResults}
                            >
                                See all options
                            </USBButton>

                            <USBButton
                                variant="secondary"
                                ariaLabel="Start questionnaire"
                                onSubmit={restartRecommender}
                            >
                                Restart Recommender
                            </USBButton>
                        </div>
                    </div>
                </div>
                <div className={styles['main-right-content']}>
                    {imageUrl && <img alt="" src={imageUrl} />}
                </div>
            </div>
        </>
    );
}

export default Recommendations;
